import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { LeftSidebar, RightSidebar } from "../../components/Social/Sidebars";
import { motion } from "framer-motion";

const MotionWrapper = motion(styled.div`
  height: 100%;
  width: 100%;
  transition: width 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-direction: column;
  padding: 2rem;
  box-sizing: border-box;
  background-color: #1a1a1a;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`);

const PageContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  color: #fff;
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    width: 100%;
  }
`;

const SocialLayout: React.FC = () => {
  return (
    <MotionWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <PageContainer>
        <LeftSidebar />

        <Outlet />

        <RightSidebar />
      </PageContainer>
    </MotionWrapper>
  );
};

export default SocialLayout;
